import { Component, OnInit, Input, HostListener, ViewChild, TemplateRef } from '@angular/core';
//import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DocDefPrimLibService } from '../../../doc-def-prim-lib.service';
import { DOData, NJDocData, modalParams, ModalParamsElem, childSearchReq } from "../../DOData"
import { wrappersService } from '../wrappers.service';
import { SectionTableComponent } from '../../section-table/section-table.component';
class clsTemplates {
    constructor(public templateCode: string,
        public value: string) { }
}
@Component({
    selector: 'cylib-modal-search-youth',
    templateUrl: './modal-search-youth.component.html',
    styleUrls: ['./modal-search-youth.component.css']
})
export class ModalSearchYouthComponent implements OnInit {
    @Input() modal_tab: string = "";
    @Input() modal_gridTemplateCode: string = "";
    @Input() modal_search_title: string = "";
    @Input() modal_search_content: string = "";
    @Input() returnData: boolean = false;
    @Input() IDType: string = "";
    @Input() MemberID: string = "";
    @Input() FirstName: string = "";
    @Input() LastName: string = "";
    @Input() DOB: string = "";
    @Input() SSN: string = "";
    @Input() Age: string = "";
    @Input() Gender: string = "";
    @Input() ParentName: string = "";
    public listTemplates: Array<clsTemplates> = new Array<clsTemplates>();
    public loaderKey: string = "Wrappers";
    private strDocDefTypeSubCode: string = "Wrappers";
	private primitives: SectionTableComponent;
    modalOptions: NgbModalOptions;
    gridRowsLength: string = '';

    isDataAvailable: boolean = false;
    showReport: boolean = false;

    public listDocdata: Array<Array<DOData>>;
    private selectedRow: Array<DOData> = new Array<DOData>();

    @ViewChild("displayTextTemplate") displayTextModal: TemplateRef<any>;
    displayTextModalRef: NgbModalRef;
    displayTextModalTitle: string = '';
    displayTextModalBody: string = '';

	constructor(public activeModal: NgbActiveModal, private dataLib: DocDefPrimLibService, private modalService: NgbModal,) {
        (window as any).pdfWorkerSrc = '/' + dataLib.ProjBaseName + 'js/pdf.worker.min.js';
    }
    public returnResponse() {
        this.activeModal.close(this.selectedRow);
    }
    public dismiss() {
        this.activeModal.dismiss(new Array<NJDocData>());
    }
    public noEntriesFound() {
        this.activeModal.dismiss("None Found");
    }
    //= "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf"
    ReportData: Uint8Array;

    params: modalParams = new modalParams();

    mobHeight: number;
    mobWidth: number;
    height: Number = 50;
    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.mobHeight = event.target.innerHeight;
        this.mobWidth = event.target.innerWidth;
        this.height = this.mobHeight * 0.5;
    }
    ngOnInit() {
        // setting default tab for the template
        this.isDataAvailable = false;
        if (this.modal_tab == "")
            this.modal_tab = "Wrappers_Tab_SelectaMemberID";
        if (this.modal_gridTemplateCode =="")
            this.modal_gridTemplateCode = "Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_Grid1_SelectaMemberGr";
        this.params.tabTemplateCode = this.modal_tab;
        this.params.loaderKey = this.loaderKey;
        this.params.strDocDefTypeSubCode = this.strDocDefTypeSubCode;
        this.params.gridTemplateCode = this.modal_gridTemplateCode;

        if (this.modal_tab =="Wrappers_Tab_SelectaMemberID") {
            this.listTemplates.push(new clsTemplates('Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_TextBox_MemberID', this.MemberID));
            this.listTemplates.push(new clsTemplates('Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_DropDown_IDType', this.IDType));
            this.listTemplates.push(new clsTemplates('Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_TextBox_FirstName', this.FirstName));
            this.listTemplates.push(new clsTemplates('Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_TextBox_LastName', this.LastName));
            this.listTemplates.push(new clsTemplates('Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_TextBox_DOB', this.DOB));
            this.listTemplates.push(new clsTemplates('Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_TextBox_SSN', this.SSN));
            this.listTemplates.push(new clsTemplates('Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_TextBox_Age', this.Age));
            this.listTemplates.push(new clsTemplates('Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_TextBox_Gender', this.Gender));
            this.listTemplates.push(new clsTemplates('Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_TextBox_ParentName', this.ParentName));
            this.listTemplates.push(new clsTemplates('Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_TextBox_ParentName', this.ParentName));
            this.listTemplates.push(new clsTemplates('Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_TextBox_TrackingElement', ''));
            for (let i: number = 0; i < this.listTemplates.length; i = i + 1) {
                let item: clsTemplates = this.listTemplates[i];
                var elem: ModalParamsElem = new ModalParamsElem();
                elem.value = item.value;
                elem.param = item.templateCode;
                this.params.lstModalParams.push(elem);
            }
        }

        console.log(this.params);
        this.dataLib.loadTab(this.params)
            .subscribe(
                (ret: boolean) => {
                    if (ret) {
                        //this.listVM = this.data.WelcomeVM;
                        let localListDocdata = new Array<Array<DOData>>();
                        for (let lstData of this.dataLib.TabVM.docdata) {
                            let newLst = new Array<DOData>();
                            for (let doData of lstData) {
                                newLst.push(DocDefPrimLibService.createNew(doData));
                            }
                            localListDocdata.push(newLst)
                        }
                        this.listDocdata = localListDocdata;
                        this.isMoreThanOne();
                        this.listDocdata[0].filter(x => {
                            if (this.gridRowsLength !== '') {
                                if (
                                    (x.njDocDefTemplate.templateCode === 'Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_Label_Multiplerecords')
                                    || (x.njDocDefTemplate.templateCode === 'Wrappers_SelectaMemberID_TOYouthSearch_CompositeMyCase_Label_Multiplerecords')) {
                                    x.njDocDefTemplate.tLabel = `${x.njDocDefTemplate.tLabel}  ${this.gridRowsLength} records`;
                                }
                            }
                        });
                    }
                },
                (err: any) => console.log(err),
                () => {
                    console.log('Complete')
                    // this does not work in IE. Method used to make IE work is depricated.
                    // When we go to a real browser we should use commented out code.
                    //window.dispatchEvent(new Event('resize'));
                    //var resizeEvent = window.document.createEvent('UIEvents');
                    //resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //window.dispatchEvent(resizeEvent);

                    //var resizeEvent = window.document.createEvent('UIEvents');
                    //resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //window.dispatchEvent(resizeEvent);

                    if (typeof (Event) === 'function') {
                        // modern browsers
                        window.dispatchEvent(new Event('resize'));
                    } else {
                        //This will be executed on old browsers and especially IE
                        var resizeEvent = window.document.createEvent('UIEvents');
                        resizeEvent.initUIEvent('resize', true, false, window, 0);
                        window.dispatchEvent(resizeEvent);
                    }
                    //this.ModalWait.close("");
                }
            );
    }
    isMoreThanOne() {
        // find grid
        let lstGrid: Array<DOData>;
        for (var i: number = 0; i < this.listDocdata.length; i++) {
            lstGrid = this.listDocdata[i].filter(function (item) {
                return item.njDocDefTemplate.tType == "Grid1"
            });
        }
        //find zip code data
        let lstGridData: Array<NJDocData> = new Array<NJDocData>();
        if (lstGrid.length == 1) {
            lstGridData = lstGrid[0].lstDocData;
        }
        //count rowids   
        let getRows = [];
        for (let i: number = 0; i < lstGridData.length; i++) {
            if (getRows.indexOf(lstGridData[i].docDefDataRowID) === -1) {
                getRows.push(lstGridData[i].docDefDataRowID);
            }
        };
        if (getRows.length == 1) {
            this.selectedRow = new Array<DOData>();
            for (let i: number = 0; i < lstGrid[0].lstDocData.length; i++) {
                let item = lstGrid[0].lstDocData[i];
                let DOMessage: DOData = new DOData();
                DOMessage.njDocData = item;
                let lstTemplate = lstGrid[0].lstChildDocDefTemplate.filter(function (item1) {
                    return item1.docDefTemplateID == item.docDefTemplateID;
                });
                if (lstTemplate.length == 1) {
                    DOMessage.njDocDefTemplate = lstTemplate[0];
                }
                this.selectedRow.push(DOMessage);
            }
            this.returnResponse();
        }
        else if (getRows.length == 0) {
            this.noEntriesFound();
        }
        this.gridRowsLength = getRows.length.toString();
        this.isDataAvailable = true;
        //console.log('zip code data count: ' + getRows.length);
    }
    onClickButton(d: DOData) {
        if (d.njDocDefTemplate.templateCode == 'Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_Button_Print') {
            this.printReport();
        }
        else if (d.njDocDefTemplate.templateCode == "Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_37807_Button_ClearSearch")
        {

            this.primitives.GridInternalAgGridComponents.first.SetFilterModel("", "");
        }
        else if (d.njDocDefTemplate.templateCode == 'Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_Button_Exit')
        {
            this.dismiss();
        }
        else if (d.njDocDefTemplate.templateCode == 'Wrappers_SelectaMemberID_TOYouthSearch_CompositeMyCase_Button_Print') {
            this.printReport();
        }
        else if (d.njDocDefTemplate.templateCode == 'Wrappers_SelectaMemberID_TOYouthSearch_CompositeMyCase_Button_ClearSearch') {
            this.primitives.GridInternalAgGridComponents.first.SetFilterModel("", "");
        }
        else {
            //on error return empty array
            this.selectedRow = new Array<DOData>();
            // find grid
            let lstGrid: Array<DOData>;
            for (var i: number = 0; i < this.listDocdata.length; i++) {
                lstGrid = this.listDocdata[i].filter(function (item) {
                    return item.njDocDefTemplate.tType == "Grid1"
                });
            };
            //find zip code data
            let lstGridData: Array<NJDocData> = new Array<NJDocData>();
            if (lstGrid.length == 1) {
                //get grid data
                lstGridData = lstGrid[0].lstDocData;
                // get selected row from col of zip key and value selected
                // find template of key from template code in custom paramater
                let templateCodeKey = lstGrid[0].customParameters.KeyColumnField;
                let lstTemplate = lstGrid[0].lstChildDocDefTemplate.filter(function (item) {
                    return item.templateCode == templateCodeKey;
                });
                if (lstTemplate.length == 1) {
                    // find template id of key
                    let docDefTemplateID = lstTemplate[0].docDefTemplateID;
                    // get NJDocData of selected item 
                    let lstdata = lstGridData.filter(function (item) {
                        return item.docDefTemplateID == docDefTemplateID && item.dataValue == d.njDocData.dataValue;
                    });
                    // get the selected row using docDefDataRowParID
                    if (lstdata.length == 1) {
                        //selected row cleared above
                        for (var item of lstGridData) {
                            if (item.docDefDataRowID == lstdata[0].docDefDataRowID) {
                                let doData = new DOData();
                                doData.njDocData = item;
                                let lstTemplate = lstGrid[0].lstChildDocDefTemplate.filter(function (item1) {
                                    return item1.docDefTemplateID == item.docDefTemplateID;
                                });
                                if (lstTemplate.length == 1) {
                                    doData.njDocDefTemplate = lstTemplate[0];
                                }
                                doData.njDocDefTemplate
                                this.selectedRow.push(doData);
                            }
                        }
                    } else if (lstdata.length > 1) {
                        for (var item of lstGridData) {
                            if (item.docDefDataRowID == lstdata[lstdata.length-1].docDefDataRowID) {
                                let doData = new DOData();
                                doData.njDocData = item;
                                let lstTemplate = lstGrid[0].lstChildDocDefTemplate.filter(function (item1) {
                                    return item1.docDefTemplateID == item.docDefTemplateID;
                                });
                                if (lstTemplate.length == 1) {
                                    doData.njDocDefTemplate = lstTemplate[0];
                                }
                                doData.njDocDefTemplate
                                this.selectedRow.push(doData);
                            }
                        }
                    }
                }
            }
        }
    }
    onGridDoubleClick(d: DOData)
    {
        if (this.returnData)
        {
            this.returnResponse();
        }
        else
        {
            switch (d.njDocDefTemplate.templateCode)
            {
                case "Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_Grid1_SelectaMemberGr":
                    {
                        let result = this.selectedRow.find(x => x.njDocDefTemplate.templateCode == "Wrappers_SelectaMemberID_TOYouthSearch_CompositeYouthS_Grid1_SelectaMemberGr_TextBox_YouthChildID").njDocData.dataValue;
                        // window.location.assign(this.dataLib.apiBaseName + "ChildSpecificFunctions/Index?loaderKey=" + this.loaderKey + "&memberID=" + result);
                        this.CheckQuickSerachResult(result);
                        break;
                    }
                case "Wrappers_SelectaMemberID_TOYouthSearch_CompositeMyCase_Grid1_SelectaMemberGr":
                    {
                        for (const item of this.selectedRow) 
                        {
                            if (item.njDocDefTemplate.templateCode === 'Wrappers_SelectaMemberID_TOYouthSearch_CompositeMyCase_Grid1_SelectaMemberGr_TextBox_YouthChildID') 
                            {
                                window.location.assign(this.dataLib.apiBaseName + "ChildSpecificFunctions/Index?loaderKey=" + this.loaderKey + "&memberID=" + item.njDocData.dataValue);
                                break;
                            }
                        }
                        break;
                    }
                default:
                    {
                        break;
                    }
            }
        }
    }

    displayTextModalModal(title: string, modalBodyText: string) {
        this.displayTextModalTitle = title;
        this.displayTextModalBody = modalBodyText;
        this.displayTextModalRef = this.modalService.open(this.displayTextModal, { backdrop: 'static', keyboard: false, size: 'sm', windowClass: 'customModalClass' });
    }

    closeDisplayTextModalModal() {
        this.displayTextModalRef.close();
    }

    CheckQuickSerachResult(memberId: string) {
        let childData: childSearchReq = new childSearchReq();
        childData.DOB = "";
        childData.firstName = "";
        childData.lastName = "";
        childData.SSN = "";
        childData.memberID = memberId;
        this.dataLib.CheckQuickSerachResult(childData).subscribe(
            (result: string) => {
                const resultCount: number = +result.split('-')[0];
                if (resultCount === 0) {
                    this.dismiss();
                    this.displayTextModalModal('Alert', 'The Search You just performed came up empty, Try search again...');
                } else if (resultCount === 1) {
                    const resultMemberId: string = result.split('-')[1];
                    const navigateURL: string = `${this.dataLib.apiBaseName}ChildSpecificFunctions/Index?loaderKey=${this.dataLib.LoaderKey}&memberID=${resultMemberId}`;
                    window.location.assign(navigateURL);
                }
            },
            (error: any) => {
                if (error.error && error.error.text) {
                    const result = error.error.text;
                    const resultCount: number = +result.split('-')[0];
                    if (resultCount === 0) {
                        this.dismiss();
                        this.displayTextModalModal('Alert', 'The Search You just performed came up empty, Try search again...');
                    } else if (resultCount === 1) {
                        const resultMemberId: string = result.split('-')[1];
                        const navigateURL: string = `${this.dataLib.apiBaseName}ChildSpecificFunctions/Index?loaderKey=${this.dataLib.LoaderKey}&memberID=${resultMemberId}`;
                        window.location.assign(navigateURL);
                    }
                }
            }
        );
    }

    report2Tab() {
        let file = new Blob([this.ReportData], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
    }
    printReport() {
        let _this = this;
        this.dataLib.loadGenerateSSRSReportStream(this.params)
            .subscribe(
                (ret: boolean) => {
                    if (ret) {
                        let localReportData = window.atob(this.dataLib.ReportdDataVM);

                        let len = localReportData.length;
                        let bytes = new Uint8Array(len);
                        for (let i = 0; i < len; i++) {
                            bytes[i] = localReportData.charCodeAt(i);
                        }

                        _this.ReportData = bytes;
                        _this.showReport = true;
                    }
                }
                ,
                (err: any) => console.log(err),
                () => {

                }
            );
    }
    onSection_tableAfterViewInit(c: SectionTableComponent) {
        this.primitives = c; //c.getPrimitives();
        //this.primitives.GridInternalAgGridComponents.first.height = 380;  //If you put this line back in, it will show an error...
    }
}
